export default __webpack_public_path__ + "locales/sr-Latn-RS/EmbeddingPanel.json?hash=a76bf1978d1b7486a6cb95eb1eca14db";